import React, {
	useEffect,
	useState
} from 'react';

import {
	Loader,
	LoadingView
} from '../../components/common/loader';

import {
	DeliverSuccessfull,
	DeliveryErrorMessages,
	SuccessMessage,
} from '../../components/common/AllConfirmationMessages';

import { PharmacistConfirmationModal } from '../../components/common/routeConfirmation';

import { PatientDetails } from '../../components/common/patientDetails';

import {
	apiKey,
	deliveryDriverDeliveredDispense
} from '../../networking/urlEndPoints';

import {
	DispenseRxData,
	// DoseFrequencySelector,
	// GenrateRxNumberDataPDF,
	// ReturnedPatches
} from '../../components/common/dispenseRxData';

import {
	SearchPatientListDeliveredByAnotherDriverAblyHelper
} from '../../utils/helper/ablyDeliveredDispenseByOthers';

import { useAllSelector } from '../../services/selectors/allSelector';
import { ErrorMessages } from '../../components/error/errorMessages';

import { fetchPatientDeliveryRx } from '../../services/apis/dispense/patientDeliveryRx';

import { useCustomStates } from '../../hooks/useCustomStates';
import { removePatientById } from '../../services/slices/dispense/patientPendingList';
import { onhandleConfirmDelivery } from '../../utils/helper/deliveriesHelper';

import { useAuthSelector } from '../../services/selectors/authSelector';
import { RemoveAllPatchesId } from '../../services/slices/dispense/validateReturnPatches';
// import { UploadTripilicatesPatientSigns } from '../../components/common/uploadTripilicatesPatientSigns';
import { clearSelectedPharmacistID } from '../../services/slices/auth/selectedPharmacist';

import { PharmacistSelection } from '../../components/common/pharmacistSelection';
import {
	InstoreDeliveryAssignmentAlert,
	InstoreDeliveryStockDecisionModal,
} from '../../components/common/instoreDeliveryContinuation';
import InstoreUnassignedHandover from '../../components/common/InstoreUnassignedHandover';
// import { NewRxesConsultationDropdown } from '../../components/common/deliveryConsultationDropdown';

import SearchBox from '../../components/common/searchBox';
import PageNotFound from '../notFound/pageNotFound';

import * as Icons from '../../assets/svg/icons';
import * as Common from '../../components/common';
import * as Hooks from '../../hooks';
import * as routeName from '../../routes/routeName';

const DeliveryStatusBadge = ({ status }) => {
	const normalizedStatus = String(status || '').trim().toLowerCase();
	const statusDetails = {
		delivered: { label: 'Delivered', className: 'border-emerald-200 bg-emerald-50 text-emerald-700' },
		pending: { label: 'Pending', className: 'border-amber-200 bg-amber-50 text-amber-700' },
		missed: { label: 'Missed today', className: 'border-red-200 bg-red-50 text-red-700' },
		today_missed: { label: 'Missed today', className: 'border-red-200 bg-red-50 text-red-700' },
		final_missed: { label: 'Final missed', className: 'border-red-200 bg-red-50 text-red-700' },
	}[normalizedStatus] || {
		label: String(status || '').replace(/_/g, ' '),
		className: 'border-slate-200 bg-slate-50 text-slate-700',
	};

	return (
		<span
			title={`Delivery status: ${statusDetails.label}`}
			className={`inline-flex min-h-7 shrink-0 items-center justify-center gap-0.5 rounded-md border px-2 text-[11px] font-semibold whitespace-nowrap ${statusDetails.className}`}
			style={{ minHeight: '28px', fontSize: '11px', lineHeight: 1 }}
		>
			<svg className="h-2.5 w-2.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
				{normalizedStatus === 'delivered' ? <path d="m5 12 4 4L19 6" /> : <><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></>}
			</svg>
			{statusDetails.label}
		</span>
	);
};

const SearchPatientList = () => {

	const dispatch = Hooks.useCustomDispatch()
	const navigate = Hooks.useCustomNavigate()

	const location = Hooks.useCustomLocation()

	const patientId = parseInt(new URLSearchParams(location.search).get('id'))
	const patient_Id = Number(patientId)

	const { confirmDeliveryResponse, patientDeliveryRxListResponse, validateReturnedPatchesResponse, pharmacistDetail } = useAllSelector();
	const { pharmacyInspectionMode, selectedPharmacistID, pharmacyId } = useAuthSelector()

	const patientsData = patientDeliveryRxListResponse?.data?.data

	const { comment,
		setComment,

		cordinate,
		setCordinate,

		patientSignature,
		setPatientSignature,

		pharmacistSignature,
		setPharmacistSignature,

		showErrorToast,
		setShowErrorToast,

		setLoading,

		showSuccessToast,
		setShowSuccessToast,

		showComment,
		setShowComment,

		showPatientSignature,
		setShowPatientSignature,

		showPharmacistSignature,
		setShowPharmacistSignature,

		showData,
		setShowData,

		showConfirmationModal,
		setShowConfirmationModal,

		isRefused,
		setIsRefused,

		signatureErrors,
		setSignatureErrors,

		covid19,
		setCovid19,

		isTransferRequest,
		setIsTransferRequest,

		consultation,
		setConsultation,

		newRxCounsellingValues,
		setNewRxCounsellingValues,

		isPatientVerified,
		setIsPatientVerified,

		selectedDoses,
		setSelectedDoses

	} = useCustomStates()

	const [showToast, setShowToast] = useState({ successToast: '' })
	const [selectedDeliverRxIds, setSelectedDeliverRxIds] = useState([])

	// Pharmacist Confirmation Modal States
	const [showPharmacistConfirmation, setShowPharmacistConfirmation] = useState(false)
	const [pendingPatientData, setPendingPatientData] = useState(null)
	const [showStockDecisionModal, setShowStockDecisionModal] = useState(false)
	const [pendingStockDecisionPatient, setPendingStockDecisionPatient] = useState(null)
	const [showFlexiConfirmation, setShowFlexiConfirmation] = useState(false)
	const [flexiProofImages, setFlexiProofImages] = useState({})
	const [copayPaymentOptions, setCopayPaymentOptions] = useState({})
	const [deliveryCompletedElsewhere, setDeliveryCompletedElsewhere] = useState(false)

	// Get Selected Pharmacist Name
	const getSelectedPharmacistName = () => {
		if (selectedPharmacistID && pharmacistDetail?.length) {
			const selectedPharmacist = pharmacistDetail.find(
				pharmacist => Number(pharmacist.id) === Number(selectedPharmacistID) || pharmacist.id == selectedPharmacistID
			);
			return selectedPharmacist?.name || '';
		}
		return '';
	};

	useEffect(() => {
		if (patientDeliveryRxListResponse?.loading) {
			setShowData(false)
			setNewRxCounsellingValues([])
			setShowPharmacistSignature(true)
			setShowPatientSignature(true)
			setShowComment(false)
			setComment('')
			setPatientSignature([null])
			setPharmacistSignature(null)
			setIsPatientVerified(true)
			dispatch(RemoveAllPatchesId())
			dispatch(clearSelectedPharmacistID(null))
			setSelectedDoses({})
			setSelectedDeliverRxIds([])
		}
	}, [patientDeliveryRxListResponse])

	const rxDataForPatient = patientsData?.rx_data || patientsData?.patients_win_rx_data_delivered || patientsData?.patients_win_rx_data
		|| patientsData?.patients_win_rx_data_today_missed || patientsData?.patients_win_rx_data_final_missed
	const totalCount = rxDataForPatient?.length ?? 0

	// Initial selection: same can_deliver logic as DispenseRxData — exclude RX only when dose data exists and every dose has can_deliver === false
	// useEffect(() => {
	// 	if (patientsData && totalCount > 0 && rxDataForPatient) {
	// 		const deliverableIds = rxDataForPatient
	// 			.filter((r) => {
	// 				if (String(r?.delivery_status || '').toLowerCase() === 'delivered') return true
	// 				const doses = r?.investigate_dilaudid_delivery_all || []
	// 				if (doses.length === 0) return true
	// 				return !doses.every((d) => d?.can_deliver === false)
	// 			})
	// 			.map((r) => r?.id)
	// 			.filter(Boolean)
	// 		setSelectedDeliverRxIds(deliverableIds)
	// 	}
	// }, [patientsData?.id, totalCount])

	useEffect(() => {
		const params = {
			id: patient_Id,
			pharmacy_id: pharmacyId
		}
		if (patientId) {
			setLoading(true)
			dispatch(fetchPatientDeliveryRx(params))
		}
		return () => { }
	}, [patient_Id])

	useEffect(() => {
		setDeliveryCompletedElsewhere(false)
	}, [patient_Id])

	useEffect(() => {
		if (!patientDeliveryRxListResponse?.loading && patientsData?.delivery_status === 'delivered') {
			setDeliveryCompletedElsewhere(false)
		}
	}, [patientDeliveryRxListResponse?.loading, patientsData?.delivery_status])

	const handleDeliveryCompletedElsewhere = () => {
		setDeliveryCompletedElsewhere(true)
		setShowData(false)
		setShowPharmacistConfirmation(false)
		setShowStockDecisionModal(false)
		setPendingPatientData(null)
		setPendingStockDecisionPatient(null)
		setSelectedDeliverRxIds([])
		setPatientSignature([null])
		setPharmacistSignature(null)
		setComment('')
		setIsPatientVerified(true)
		dispatch(clearSelectedPharmacistID(null))
		dispatch(fetchPatientDeliveryRx({
			id: patient_Id,
			pharmacy_id: pharmacyId
		}))
	}

	const isDeliveryLocked = deliveryCompletedElsewhere || patientsData?.delivery_status === 'delivered'

	const handleConfirmDelivery = (patient_id) => {
		// if (!isRefused && (!patientSignature || patientSignature[0] == null)) {
		// 	setSignatureErrors(prevState => ({ ...prevState, patientSign: '1px solid red' }));
		// 	return;
		// }
		setPendingPatientData(patient_id);
		// Only show Confirm Pharmacist popup when there is a pharmacist signature on the pad
		if (pharmacistSignature) {
			setShowPharmacistConfirmation(true);
		} else {
			// No pharmacist sign – continue delivery without showing the modal
			requestStockDecisionOrProceed(patient_id);
			setPendingPatientData(null);
		}
	}

	const proceedWithDelivery = () => {
		setShowPharmacistConfirmation(false);
		const patient_id = pendingPatientData;

		if (!patient_id) {
			setPendingPatientData(null);
			return;
		}

		requestStockDecisionOrProceed(patient_id);
		setPendingPatientData(null);
	}

	const requestStockDecisionOrProceed = (patientData) => {
		if (patientData?.instore_delivery_assignment?.assigned) {
			setPendingStockDecisionPatient(patientData);
			setShowStockDecisionModal(true);
			return;
		}

		processDeliveryLogic(patientData);
	}

	const processDeliveryLogic = (patient_id, deliveryStockDisposition = null, deliveryStockSignature = null) => {
		const allPatientsRxData = (patientsData?.rx_data ||
			patientsData?.patients_win_rx_data_delivered ||
			patientsData?.patients_win_rx_data ||
			patientsData?.patients_win_rx_data_today_missed ||
			patientsData?.patients_win_rx_data_final_missed);

		const patientDataForHelper = { ...patient_id, patients_win_rx_data: allPatientsRxData };

		onhandleConfirmDelivery(
			patientDataForHelper,
			0,
			pharmacyId,
			selectedPharmacistID,
			patientSignature,
			pharmacistSignature,
			cordinate,
			comment,
			dispatch,
			setLoading,
			() => {},
			setShowErrorToast,
			setShowSuccessToast,
			pharmacyInspectionMode,
			isRefused,
			covid19,
			'patient_search_list',
			setIsRefused,
			setSignatureErrors,
			validateReturnedPatchesResponse,
			isTransferRequest,
			setIsTransferRequest,
			consultation,
			newRxCounsellingValues,
			selectedDoses,
			{},
			{},
			{ patientId: patientId, type: 'patient_search_list' },
			isPatientVerified,
			selectedDeliverRxIds,
			deliveryStockDisposition,
			deliveryStockSignature
		);
	}

	const handleStockDecision = (deliveryStockDisposition, deliveryStockSignature = null) => {
		if (pendingStockDecisionPatient) {
			processDeliveryLogic(pendingStockDecisionPatient, deliveryStockDisposition, deliveryStockSignature);
		}
		setShowStockDecisionModal(false);
		setPendingStockDecisionPatient(null);
	}

	const handlePharmacistConfirmationCancel = () => {
		setShowPharmacistConfirmation(false);
		setPharmacistSignature(null);
		setPendingPatientData(null);
	}

	const handleStockDecisionCancel = () => {
		setShowStockDecisionModal(false);
		setPendingStockDecisionPatient(null);
	}

	return (
		<>
			{
				pharmacyId && patientId ? <>
					<div className="app-wrapper flex justify-center">
						<div className="app-screen no-shades w-full h-full  overflow-x-hidden ">
							<div className="relative p-4">
								<div className="card bg-white p-4 rounded-lg shadow-sm">
									<div className="flex items-center justify-between gap-3">
										<div>
											<Common.TopBar pharmacyId={pharmacyId} />
										</div>
										<div className='flex items-center justify-center btnnn pt-4' onClick={() => navigate(routeName.DASHBOARD_PHARMACY)} >
											<Icons.HomeIcon />
										</div>
									</div>
								</div>

								<div className="flex gap-3 mb-3">
									<SearchBox pharmacyId={pharmacyId} />
								</div>

								<div className="routes-list">

									{(patientDeliveryRxListResponse?.loading) ?

										<div className='h-96'>
											<LoadingView />
										</div> :

										patientDeliveryRxListResponse?.error !== null ?

											<div className='flex items-center justify-center pb-4 mb-4 h-96'>
												<ErrorMessages error={'Oops! Got an issue while fetching Data.Please try again!'} />
											</div> :

											patientDeliveryRxListResponse?.data === null ? null :
												<>
													<div className="card bg-white px-4 py-3 rounded-lg shadow-sm mb-3 mt-2">
														<PatientDetails
															data={patientsData}
															totalRxData={totalCount}
															index={0}
															patientImg={patientsData?.profile_image}
															profileImageInputId="selectProfileImage"
															alwaysShowChildren
															headerRight={
															patientsData?.delivery_status
																? <DeliveryStatusBadge status={patientsData.delivery_status} />
																: null
															}
															headerAction={<InstoreUnassignedHandover patient={patientsData} selectedRxIds={selectedDeliverRxIds} />}
														>
															<>
																<InstoreDeliveryAssignmentAlert assignment={patientsData?.instore_delivery_assignment} />
																<DispenseRxData
																	rxData={rxDataForPatient}
																	signatureErrors={signatureErrors}
																	type="new_rx"
																	newRxCounsellingValues={newRxCounsellingValues}
																	setNewRxCounsellingValues={setNewRxCounsellingValues}
																	patientData={patientsData}
																	selectedDoses={selectedDoses}
																	setSelectedDoses={setSelectedDoses}
																	flexiProofImages={flexiProofImages}
																	setFlexiProofImages={setFlexiProofImages}
																	copayPaymentOptions={copayPaymentOptions}
																	setCopayPaymentOptions={setCopayPaymentOptions}
																	selectedDeliverRxIds={selectedDeliverRxIds}
																	setSelectedDeliverRxIds={setSelectedDeliverRxIds}
																	isActiveDeliverRxCard={true}
																	deliverRxSelectionEnabled={!isDeliveryLocked}
																/>

																{!isDeliveryLocked &&
																	<PharmacistSelection
																		signatureErrors={signatureErrors}
																		setSignatureErrors={setSignatureErrors}
																		setShowData={setShowData}
																	/>}

																{showData && !isDeliveryLocked && patientsData?.delivery_status !== '' &&
																	<React.Fragment>
																		<div className="mb-3">
																			<Common.DeliveryConsultationDropdown consultation={consultation}
																				setConsultation={setConsultation} />
																		</div>
																				<div className="flex flex-col md:flex-row gap-3 mb-3 items-start">
																			<Common.PatientSignature patientSignature={patientSignature}
																				setPatientSignature={setPatientSignature}
																				showPatientSignature={showPatientSignature}
																				setShowPatientSignature={setShowPatientSignature}
																				setIsRefused={setIsRefused}
																				isRefused={isRefused}
																				signatureErrors={signatureErrors}
																				setSignatureErrors={setSignatureErrors}
																				covid19={covid19}
																				setCovid19={setCovid19}
																				rxData={rxDataForPatient}
																			/>
																			<Common.PharmacistSignature
																				pharmacistSignature={pharmacistSignature}
																				setPharmacistSignature={setPharmacistSignature}
																				showPharmacistSignature={showPharmacistSignature}
																				setShowPharmacistSignature={setShowPharmacistSignature}
																				signatureErrors={signatureErrors}
																				setSignatureErrors={setSignatureErrors}
																				selectedPharmacistID={selectedPharmacistID}
																				pharmacistDetail={pharmacistDetail}
																			/>
																		</div>
																		<Common.Comment showComment={showComment}
																			setShowComment={setShowComment}
																			setComment={setComment} comment={comment} />
																		<Common.PatientVerified
																			isPatientVerified={isPatientVerified}
																			setIsPatientVerified={setIsPatientVerified}
																		/>
																	</React.Fragment>
																}

																{!isDeliveryLocked && patientsData?.delivery_status !== '' && selectedPharmacistID && (() => {
																	const noRxSelected = !selectedDeliverRxIds || selectedDeliverRxIds.length === 0
																	return (
																		<div className="flex items-center gap-3">
																			{showData
																				? (validateReturnedPatchesResponse?.loading ? null : (
																					showFlexiConfirmation ? (
																						<button className="px-4 flex-1 py-2 bg-[#10b981] text-white rounded-md" onClick={() => window.location.reload()}>
																							Reload
																						</button>
																					) : (
																						<button
																							className={`px-4 flex-1 py-2 rounded-md ${noRxSelected ? 'bg-gray-300 text-gray-500 cursor-not-allowed' : 'text-white'}`}
																							style={noRxSelected ? undefined : { backgroundColor: '#10b981' }}
																							disabled={noRxSelected}
																							onClick={() => { if (noRxSelected) return; handleConfirmDelivery(patientsData); }}
																						>
																							{confirmDeliveryResponse?.loading ? <p className='flex justify-center items-center'><Loader /></p> : 'Continue'}
																						</button>
																					)
																				))
																				: (
																					<button
																						className={`px-4 flex-1 py-2 rounded-md ${noRxSelected ? 'bg-gray-300 text-gray-500 cursor-not-allowed' : 'text-white'}`}
																						style={noRxSelected ? undefined : { backgroundColor: '#10b981' }}
																						disabled={noRxSelected}
																						onClick={() => {
																							if (noRxSelected) return;
																							setShowData(true);
																							setTimeout(() => {
																								const windowHeight = window.innerHeight;
																								const scrollAmount = windowHeight / 2;
																								window.scrollBy({ top: scrollAmount, behavior: "smooth" });
																							}, 100);
																						}}
																					>
																						Deliver
																					</button>
																				)
																			}
																		</div>
																	)
																})()}
															</>
														</PatientDetails>
													</div>
												</>
									}

								</div>
							</div>
						</div>
					</div>

				{showErrorToast && <DeliveryErrorMessages setShowErrorToast={setShowErrorToast} message={typeof showErrorToast === 'string' ? showErrorToast : undefined} />}
				{showSuccessToast && <DeliverSuccessfull setShowSuccessToast={setShowSuccessToast} />}
				{showToast.successToast && <SuccessMessage message={'Profile Updated Successfully.'} setShowToast={() => setShowToast(prevState => ({ ...prevState, successToast: false }))} />}

				<PharmacistConfirmationModal
					showModal={showPharmacistConfirmation}
					setShowModal={setShowPharmacistConfirmation}
					pharmacistName={getSelectedPharmacistName()}
					onConfirm={proceedWithDelivery}
					onCancel={handlePharmacistConfirmationCancel}
				/>

				<InstoreDeliveryStockDecisionModal
					showModal={showStockDecisionModal}
					patientName={[pendingStockDecisionPatient?.first_name, pendingStockDecisionPatient?.last_name].filter(Boolean).join(' ')}
					signingAsName={getSelectedPharmacistName()}
					onTakeNow={(signature) => handleStockDecision('take_now', signature)}
					onReturnEndOfDay={() => handleStockDecision('return_end_of_day')}
					onCancel={handleStockDecisionCancel}
				/>

				<SearchPatientListDeliveredByAnotherDriverAblyHelper
						apiKey={apiKey}
						deliveryDriverDeliveredDispense={deliveryDriverDeliveredDispense}
						pharmacyId={pharmacyId}
						dispatch={dispatch}
						setCordinate={setCordinate}
						setLoading={setLoading}
						patientId={patientId}
						removePatientById={removePatientById}
						onDeliveredElsewhere={handleDeliveryCompletedElsewhere}
					/>

				</> : <PageNotFound />}
		</>
	)
}

export default SearchPatientList
